<template>
	<div class="about-page py-12">
		<v-container>
			<v-row justify="center">
				<v-col cols="12" sm="8" md="6" lg="5">
					<v-card class="about-card pa-8 text-center rounded-xl" flat outlined>
						<v-avatar size="88" color="#eff6ff" class="mb-4 about-avatar">
							<v-img src="img/favicon.png" contain></v-img>
						</v-avatar>

						<h2 class="text-h6 font-weight-bold text-slate-900 mb-1">Newton Store</h2>
						<p class="caption text-secondary-custom mb-6">Plataforma de comercio electrónico y gestión</p>

						<v-divider class="mb-6"></v-divider>

						<v-list dense class="pa-0 text-left">
							<v-list-item
								href="mailto:gerencia@eycproveedores.com"
								target="_blank"
								class="rounded-lg mb-2 contact-item"
							>
								<v-list-item-avatar size="36" color="#f1f5f9">
									<v-icon small color="primary">mdi-email-outline</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-subtitle class="caption text-secondary-custom">Correo electrónico</v-list-item-subtitle>
									<v-list-item-title class="caption font-weight-bold text-slate-800"
										>gerencia@eycproveedores.com</v-list-item-title
									>
								</v-list-item-content>
							</v-list-item>

							<v-list-item href="tel:+573183383072" target="_blank" class="rounded-lg mb-2 contact-item">
								<v-list-item-avatar size="36" color="#f1f5f9">
									<v-icon small color="primary">mdi-phone-outline</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-subtitle class="caption text-secondary-custom"
										>Teléfono de contacto</v-list-item-subtitle
									>
									<v-list-item-title class="caption font-weight-bold text-slate-800"
										>+57 318 338 3072</v-list-item-title
									>
								</v-list-item-content>
							</v-list-item>

							<v-list-item href="http://eycproveedores.com" target="_blank" class="rounded-lg contact-item">
								<v-list-item-avatar size="36" color="#f1f5f9">
									<v-icon small color="primary">mdi-web</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-subtitle class="caption text-secondary-custom">Sitio web oficial</v-list-item-subtitle>
									<v-list-item-title class="caption font-weight-bold text-slate-800"
										>eycproveedores.com</v-list-item-title
									>
								</v-list-item-content>
							</v-list-item>
						</v-list>

						<v-divider class="my-6"></v-divider>

						<div class="caption text-secondary-custom">
							&copy; {{ new Date().getFullYear() }} Newton Developers. Todos los derechos reservados.
						</div>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
export default {
	name: "About",
};
</script>

<style scoped>
.about-page {
	min-height: 80vh;
	background-color: #f8fafc;
}

.about-card {
	background-color: #ffffff !important;
	border: 1px solid #eef2f6 !important;
	box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04) !important;
}

.about-avatar {
	margin: 0 auto;
	border: 2px solid #e2e8f0;
}

.contact-item {
	background-color: #f8fafc;
	border: 1px solid #f1f5f9;
	transition: background-color 0.15s ease;
}

.contact-item:hover {
	background-color: #eff6ff;
}

.text-slate-900 {
	color: #0f172a;
}

.text-slate-800 {
	color: #1e293b;
}

.text-secondary-custom {
	color: #64748b;
}
</style>
